export default __webpack_public_path__ + "static/media/loginBg.b60bd162.png";